<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="6" style="padding:20px 10px;font-size: 20px;font-weight: bold;">
					详情页
				</el-col>
				<el-col :span="2" :offset="16" style="padding:10px 20px;">
					<el-button @click="back" size="mini">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div style="margin:0 10px;">
			<div class="msg">
				<el-row class="msgLine" style="background-color:#E2E2E2;">
					<el-col :span="4">
						<span class="label">名称</span>：aaa
					</el-col>
					<el-col :span="4">
						<span class="label">次数</span>：aaa
					</el-col>
					<el-col :span="4">
						<span class="label">操作员</span>：aaa
					</el-col>
				</el-row>
				<el-row class="msgLine">
					<el-col :span="4">
						<span class="label">顾客</span>：aaa
					</el-col>
					<el-col :span="4">
						<span class="label">手机号</span>：aaa
					</el-col>
					<el-col :span="4">
						<span class="label">宠物昵称</span>：aaa
					</el-col>
					<el-col :span="4">
						<span class="label">品种</span>：aaa
					</el-col>
					<el-col :span="4">
						<span class="label">性别</span>：aaa
					</el-col>
					<el-col :span="4">
						<span class="label">年龄</span>：aaa
					</el-col>
				</el-row>
				<el-row class="msgLine">
					<el-col :span="4">
						<span class="label">已核销</span>：aaa
					</el-col>
					<el-col :span="4">
						<span class="label">核销时间</span>：aaa
					</el-col>
					<el-col :span="4">
						<span class="label">备注</span>：aaa
					</el-col>
				</el-row>
			</div>
			<el-row style="padding:10px 20px 0;">
				<el-button style="margin-top:10px;" type="text" @click="zhuyuanTableState=!zhuyuanTableState">
					关联单号<i class="el-icon--right" :class="zhuyuanTableState?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
				</el-button>
				<el-table v-show="zhuyuanTableState" :data="tableData" style="width:1200px;margin-left:30px;">
					<el-table-column label="编号" width="80">
						<template slot-scope="props">
							{{parseInt(props.$index+1)}}
						</template>
					</el-table-column>
					<el-table-column label="单号">
						<template slot-scope="props">
							<span class="biaoqianA" @click="toBingliSee(props.row.caseNumber)">{{props.row.caseNumber}}</span>
						</template>
					</el-table-column>
					<el-table-column label="销售日期" width="200">
						<template slot-scope="props">
							<div>{{$public.FTime(props.row.caseDate,'YYYY-MM-DD')}}</div>
						</template>
					</el-table-column>
					<el-table-column label="总金额" width="200">
						<template slot-scope="props">
							<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD HH:mm')}}</div>
						</template>
					</el-table-column>
					<el-table-column label="支付方式" width="150">
						<template slot-scope="props">
							<div style="color:#FD4E4E" v-if="props.row.isInspect==0">未检测</div>
							<div style="color:#18A44C" v-if="props.row.isInspect==1">已检测</div>
						</template>
					</el-table-column>
					<el-table-column label="类型" width="150">
						<template slot-scope="props">
							<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
							<div style="color:#FD4E4E" v-else>未支付</div>
						</template>
					</el-table-column>
					<el-table-column label="创建门店" width="150">
						<template slot-scope="props">
							<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
							<div style="color:#FD4E4E" v-else>未支付</div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="200" prop="remark">
					</el-table-column>
					<el-table-column label="操作" width="200" prop="remark">
					</el-table-column>
				</el-table>
			</el-row>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				indexs:[],
				tableData:[],
				zhuyuanTableState:true,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
		},
		mounted(){
			this.getDetail();
		},
		methods: {
			back(){
				this.$store.commit('huiyuanquanyi/set_type','see')
			},
			switchIndexs(num){
				let index = -1;
				for(let i=0;i<this.indexs.length;i++){
					if(this.indexs[i]===num){
						index=i
					}
				}
				if(index===-1){
					this.indexs.push(num)
				}else{
					this.indexs.splice(index,1)
				}
			},
			seesee(num){
				console.log(num)
				this.$store.commit('huiyuanquanyi/set_type','seesee')
			},
			// 获取寄养列表
			getDetail() {
				let loading=this.$loading();
				let params = {
				}
				console.log(params)
				this.$http.post('/api/Case/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:0 0 20px;box-sizing: border-box;overflow: auto;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:8px 8px 8px;
		box-sizing: border-box;
	}
	.msg{
		padding: 0 0 0 20px;
		.msgLine{
			padding:0 10px;
			.label{
				line-height: 40px;font-size: 14px;color:#505050;
			}
		}
		
	}
}
</style>
